import { Runtime, useSiteInfo } from '@silvertours/front-entities';
import { useMedia } from 'react-use';
import { TrustPilotDe, TrustPilotFr } from './TrustElements/TrustPilot';
import { AppPromotion } from './TrustElements/AppPromotion';
import { TrustElement, TrustWrapper } from './TrustSeals.styles';

const TrustSeals = () => {
  const {
    settings: { featureToggles },
  } = useSiteInfo();
  const { language } = Runtime.useLocale();
  const isLargeViewport = useMedia('(min-width: 992px)', false);

  if (!isLargeViewport || !featureToggles.trustElementOnStageImage) {
    return null;
  }

  if (language === 'de') {
    return (
      <TrustWrapper>
        <TrustElement isHighlighted>
          <AppPromotion />
        </TrustElement>
        <TrustElement>
          <TrustPilotDe />
        </TrustElement>
      </TrustWrapper>
    );
  }

  if (language === 'fr') {
    return (
      <TrustWrapper>
        <TrustElement isHighlighted>
          <AppPromotion />
        </TrustElement>
        <TrustElement>
          <TrustPilotFr />
        </TrustElement>
      </TrustWrapper>
    );
  }

  return null;
};

export { TrustSeals };
